import { Card } from "../../models/card";
import { cards } from "../../state";
import { BlueGolem } from "../upgrades/blueGolem";
export class MakeBlueGolem extends Card {
}
MakeBlueGolem.displayName = "Blue Golem";
MakeBlueGolem.artUrl = "./assets/cards/bluegolem.jpg";
MakeBlueGolem.effect = {
    callback: () => {
        cards.push(new BlueGolem({ x: 150, y: 240 }));
    },
    description: "Craft a Blue Golem. This one is trying.",
    needsFeedback: true,
};
MakeBlueGolem.destroysOnPlay = true;
